import { render, staticRenderFns } from "./Diferenciais.vue?vue&type=template&id=1dd25c69&scoped=true&"
import script from "./Diferenciais.vue?vue&type=script&lang=js&"
export * from "./Diferenciais.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dd25c69",
  null
  
)

export default component.exports